import AppRouters from "./routers/AppRouters";
import "antd/dist/antd.css";
import 'firebase/firestore';
import './App.css'


function App() {
  return (<AppRouters />)
}

export default App;
